import {
  getNftContractFromTx,
  resolveNftCollectionDisplayName,
  KNOWN_NFT_COLLECTIONS,
} from "./nftCollections.js";

export const THORHEAD_ICON_SRC = "/thorhead.jpg";
export const GOATZ_ICON_SRC = "/goatz.png";
export const VEMUGS_ICON_SRC = "/vemugs.png";
export const DEFAULT_NFT_ICON_SRC = "/nft-icon.svg";

const THORHEADS_CONTRACT = "0x24ee6e8d0ffcca3d73eada5c8585301f2bc10d60";
const FEMALE_GOATZ_CONTRACT = "0x61d6e954b90d6506ce6964682744bfc2d51abebd";
const VEMUGS_NFT_CONTRACT = "0xff0ffb2167ae0b6a8af185df4cd4fe5f76ad9982";

export { KNOWN_NFT_COLLECTIONS, getNftContractFromTx, resolveNftCollectionDisplayName };

export function getNftDisplayName(tx = {}) {
  return resolveNftCollectionDisplayName(tx);
}

export function getNftContract(tx = {}) {
  return getNftContractFromTx(tx);
}

function collectionHint(tx = {}) {
  return String(
    getNftDisplayName(tx) ||
      tx?.nftName ||
      tx?.nft_name ||
      tx?.name ||
      tx?.relatedMintNftName ||
      tx?.related_mint_nft_name ||
      tx?.collection_name ||
      tx?.collectionName ||
      ""
  ).toLowerCase();
}

/** true wenn Name/Untertitel „Thorheads“ ist (Mint, Sale, Received, …) */
export function isThorheadsNft(tx = {}) {
  const name = collectionHint(tx);
  if (name.includes("thorhead")) return true;

  const contract = getNftContract(tx);
  if (contract === THORHEADS_CONTRACT) return true;

  return false;
}

export function isGoatzNft(tx = {}) {
  const name = collectionHint(tx);
  if (name.includes("goatz")) return true;

  const contract = getNftContract(tx);
  if (contract === FEMALE_GOATZ_CONTRACT) return true;

  return false;
}

export function isVeMugsNft(tx = {}) {
  const name = collectionHint(tx);
  if (name.includes("vemug")) return true;

  const appHint = String(
    tx?.application ||
      tx?.protocol ||
      tx?.sourcePlatform ||
      tx?.providerSuggestedLabel ||
      ""
  ).toLowerCase();
  if (appHint.includes("vemug")) return true;

  const contract = getNftContract(tx);
  if (contract === VEMUGS_NFT_CONTRACT) return true;

  return false;
}

export function getNftIconSrc(tx = {}, fallback = DEFAULT_NFT_ICON_SRC) {
  if (isThorheadsNft(tx)) return THORHEAD_ICON_SRC;
  if (isGoatzNft(tx)) return GOATZ_ICON_SRC;
  if (isVeMugsNft(tx)) return VEMUGS_ICON_SRC;
  return fallback;
}

export function getNftIconAlt(tx = {}) {
  if (isThorheadsNft(tx)) return "Thorheads";
  if (isGoatzNft(tx)) return "Goatz Club";
  if (isVeMugsNft(tx)) return "VeMugs";
  return "NFT";
}

export function resolveNftIconSrc(tx = {}, explicitSrc) {
  if (explicitSrc && explicitSrc !== DEFAULT_NFT_ICON_SRC) return explicitSrc;
  return getNftIconSrc(tx);
}
